export default __webpack_public_path__ + "static/media/product-tour6.11eac0af.svg";